import { AppMode } from '@iheartjane/dm-sdk';
import type { ProductKind } from '@iheartjane/types';

import { categories } from '@jane/kiosk/util/lib/categories/categories';
import type { Store } from '@jane/shared/types';
import { generateCustomLabel } from '@jane/shared/util';

import { isMenuCategory } from '../categories/menuCategory';
import type { MenuCategory } from '../categories/menuCategory';

interface CustomCategoryLabelArgs {
  kind: ProductKind | MenuCategory;
  store: Store;
}

export const customCategoryLabel = ({
  kind,
  store,
}: CustomCategoryLabelArgs) => {
  const label = generateCustomLabel({
    appMode: AppMode.Kiosk,
    store,
    attribute: kind,
    fallback: kind,
  });

  return isMenuCategory(label) ? categories[label].title : label;
};
